import LazyUtil from "../../core/util/lazy_util";
import { ItemJsEnv } from '../models/item_js_env';

interface LazyloadReplace {
  option: {
    htmlId: string,
    replaceFrom: string,
    replaceTo: string
  }
}
export class PrintedItemLinkAction{
  static init(env: ItemJsEnv) {
    if (env.printedItemPath) {
      const lazyloadReplace: LazyloadReplace = {
        option: {
          htmlId: "printedItemLinkId",
          replaceFrom: "printedNamePath",
          replaceTo: env.printedItemPath
        }
      }
      LazyUtil.registerFiredEvent(
        lazyloadReplace.option.htmlId,
        (e: HTMLElement) => {
          if (e.innerHTML) {
            e.innerHTML = e.innerHTML.replace(
              lazyloadReplace.option.replaceFrom,
              lazyloadReplace.option.replaceTo
            );
          }
        }
      )
    }
  }
}
